import React from "react";

const LazyBar = React.lazy(() => 
    import('react-chartjs-2').then(mod => ({ default: mod.Bar }))
);
export default LazyBar;
